export default __webpack_public_path__ + "static/media/Jennifer Dsouza.c34dfd7f.jpg";